"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const validator_1 = __importDefault(require("validator"));
const StoresUtil_1 = require("../../util/StoresUtil");
const AccessDataContent_1 = require("../privacynotice/contactmodalcontents/AccessDataContent");
const CorrectDataContent_1 = require("../privacynotice/contactmodalcontents/CorrectDataContent");
const DataTransferContent_1 = require("../privacynotice/contactmodalcontents/DataTransferContent");
const ForgottenContent_1 = require("../privacynotice/contactmodalcontents/ForgottenContent");
const LimitProcessingContent_1 = require("../privacynotice/contactmodalcontents/LimitProcessingContent");
const ContactForm_1 = require("./ContactForm");
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
let ContactFormContent = class ContactFormContent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactFormStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getContentByType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { contactFormType } = this.props;
                switch (contactFormType) {
                    case ContactForm_1.ContactFormType.CORRECT_DATA:
                        this.contactFormStore.emailContent.requestType = 'Õigus andmete parandamisele';
                        return react_1.default.createElement(CorrectDataContent_1.CorrectDataContent, null);
                    case ContactForm_1.ContactFormType.ACCESS_DATA:
                        this.contactFormStore.emailContent.requestType = 'Õigus tutvuda andmetega';
                        return react_1.default.createElement(AccessDataContent_1.AccessDataContent, null);
                    case ContactForm_1.ContactFormType.DATA_TRANSFER:
                        this.contactFormStore.emailContent.requestType = 'Õigus andmete ülekandmisele';
                        return react_1.default.createElement(DataTransferContent_1.DataTransferContent, null);
                    case ContactForm_1.ContactFormType.FORGOTTEN:
                        this.contactFormStore.emailContent.requestType = 'Õigus olla unustatud';
                        return react_1.default.createElement(ForgottenContent_1.ForgottenContent, null);
                    case ContactForm_1.ContactFormType.LIMIT_PROCESSING:
                        this.contactFormStore.emailContent.requestType = 'Õigus piirata oma isikuandmete töötlemist';
                        return react_1.default.createElement(LimitProcessingContent_1.LimitProcessingContent, null);
                    case ContactForm_1.ContactFormType.CONTACT_US:
                    default:
                        this.contactFormStore.emailContent.requestType = 'Õigus pöörduda Telia poole';
                        return null;
                }
            }
        });
    }
    async componentDidMount() {
        if ((this.ssoStore.isLoggedInWithHardAuth || this.ssoStore.isDealer) && this.ssoStore.isPrivateCustomer) {
            await this.populateTextFieldContactInfos();
        }
    }
    async populateTextFieldContactInfos() {
        await this.contactInfoStore.loadRepresentativeContactInfos();
        (0, mobx_1.runInAction)(() => {
            var _a, _b;
            this.contactFormStore.emailContent.from = ((_a = this.contactInfoStore.emailInfo) === null || _a === void 0 ? void 0 : _a.value) || '';
            this.contactFormStore.emailContent.phone = ((_b = this.contactInfoStore.phoneInfo) === null || _b === void 0 ? void 0 : _b.value) || '';
        });
    }
    get shouldShowEmailHelper() {
        var _a;
        return this.ssoStore.isHardAuthWithCustomer && ((_a = this.contactInfoStore.emailInfo) === null || _a === void 0 ? void 0 : _a.value) !== this.contactFormStore.emailContent.from;
    }
    get shouldShowPhoneHelper() {
        var _a;
        return this.ssoStore.isHardAuthWithCustomer && ((_a = this.contactInfoStore.phoneInfo) === null || _a === void 0 ? void 0 : _a.value) !== this.contactFormStore.emailContent.phone;
    }
    get shouldShowHardAuthNeededNotice() {
        const { isHardAuthWithCustomer, isDealerWithoutSelectedCustomer, isDealer } = this.ssoStore;
        const { contactFormType } = this.props;
        if (isDealer) {
            return isDealerWithoutSelectedCustomer && contactFormType !== ContactForm_1.ContactFormType.CONTACT_US;
        }
        else {
            return !isHardAuthWithCustomer && contactFormType !== ContactForm_1.ContactFormType.CONTACT_US;
        }
    }
    render() {
        const { translate } = this.translateStore;
        const { textAreaComment } = this.props;
        if (this.shouldShowHardAuthNeededNotice) {
            return react_1.default.createElement(lib_1.Notice, { type: "info" }, this.translateStore.translate('gdpr.privacy.contact.logInWithHardAuth'));
        }
        return (react_1.default.createElement(lib_1.Text, null,
            this.getContentByType(),
            react_1.default.createElement(lib_1.Grid, { className: "text__margin-double" },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12'] },
                    react_1.default.createElement(lib_1.Text, null,
                        react_1.default.createElement(lib_1.TextField, { isInvalid: !(validator_1.default.isEmpty(this.contactFormStore.emailContent.from) || this.contactFormStore.isEmailValid), id: "email-field", label: translate('contactInfo.email'), value: this.contactFormStore.emailContent.from, helper: this.shouldShowEmailHelper && {
                                type: 'help',
                                text: translate('gdpr.privacy.contact.contactInfoWillNotBeSavedHelper')
                            }, onChange: (value) => (0, mobx_1.runInAction)(() => (this.contactFormStore.emailContent.from = value)) }),
                        react_1.default.createElement(lib_1.TextField, { isInvalid: !this.contactFormStore.isPhoneValid, id: "mobile-field", label: translate('gdpr.privacy.contact.phone'), value: this.contactFormStore.emailContent.phone, helper: this.shouldShowPhoneHelper && {
                                type: 'help',
                                text: translate('gdpr.privacy.contact.contactInfoWillNotBeSavedHelper')
                            }, onChange: (value) => (0, mobx_1.runInAction)(() => (this.contactFormStore.emailContent.phone = value)) }),
                        react_1.default.createElement(lib_1.TextArea, { isInvalid: !(validator_1.default.isEmpty(this.contactFormStore.emailContent.body) || this.contactFormStore.isBodyValid), id: "comment-field", label: translate('gdpr.privacy.contact.comment'), onChange: (value) => (0, mobx_1.runInAction)(() => (this.contactFormStore.emailContent.body = value)), helper: textAreaComment && {
                                text: textAreaComment,
                                type: 'help'
                            } })),
                    react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xsmall" }),
                    react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: "6Le_plMUAAAAAJYaybMKyOGEUOOSafB5B7xn-XEY", onChange: () => (0, mobx_1.runInAction)(() => (this.contactFormStore.captchaPassed = true)) })))));
    }
};
__decorate([
    mobx_1.computed
], ContactFormContent.prototype, "shouldShowEmailHelper", null);
__decorate([
    mobx_1.computed
], ContactFormContent.prototype, "shouldShowPhoneHelper", null);
__decorate([
    mobx_1.computed
], ContactFormContent.prototype, "shouldShowHardAuthNeededNotice", null);
ContactFormContent = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactFormContent);
exports.default = ContactFormContent;
